<wm-form-activity-input-view [activity]="activity" [form]="form" [showSubmitButton]="false">
</wm-form-activity-input-view>
